import { create } from 'zustand';

type Store = {
  isOpen: boolean;
  setOpen: (isOpen: boolean) => void;
};

export const useTradeFlowPriceChartStore = create<Store>((set) => ({
  isOpen: true,
  setOpen(isOpen) {
    set({
      isOpen,
    });
  },
}));
